var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',{directives:[{name:"number",rawName:"v-number"}],staticClass:"phone-input",attrs:{"maxlength":10,"placeholder":_vm.placeholder,"type":"number"},model:{value:(_vm.setInput),callback:function ($$v) {_vm.setInput=$$v},expression:"setInput"}},[_c('template',{slot:"prepend"},[_c('div',{staticClass:"is-flex is-align-center"},[_c('img',{style:({
          height: '15px',
          borderRadius: '2px',
          marginRight: '6px',
        }),attrs:{"slot":"prefix","src":_vm.getCountryFlag(_vm.location),"alt":"code"},slot:"prefix"}),_c('span',{staticClass:"font-base"},[_vm._v(" +"+_vm._s(_vm.countryCode)+" ")])])])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }